import gql from 'graphql-tag';

export const alternativeQuery = gql`
  query topTools {
    topTools(first: 40) {
      edges {
        node {
          id
          name
          imageUrl
          slug
          alternativeTools(first: 3) {
            edges {
              node {
                id
                name
                title
                verified
                canonicalUrl
                imageUrl
                slug
                following
                stacks
                fans
                votes
              }
            }
          }
        }
      }
    }
  }
`;
